import { useLanguage } from '../contexts/language';
import ConfirmationDialog from './ConfirmationDialog';

type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const LosingChangesConfimationDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmationModalProps) => {
  const { t } = useLanguage();

  return (
    <ConfirmationDialog
      open={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('content.confirm-losing-changes')}
    >
      <p>{t('content.unsaved-changes-warning')}</p>
    </ConfirmationDialog>
  );
};

export default LosingChangesConfimationDialog;
